function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Creator-2.0",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ingredients---Empty-1",
  transform: "translate(-645.000000, -210.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ingredients-Empty",
  transform: "translate(260.000000, 152.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(370.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "No-Recipes",
  transform: "translate(15.603448, 2.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M149.793103,97.5 C149.793103,56.07875 116.260669,22.5 74.8965517,22.5 C33.5324345,22.5 0,56.07875 0,97.5 L149.793103,97.5 Z",
  id: "Fill-2",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.5344828,46.875 C65.5344828,41.6975 61.3427724,37.5 56.1724138,37.5 C51.0020552,37.5 46.8103448,41.6975 46.8103448,46.875 C46.8103448,52.0525 51.0020552,56.25 56.1724138,56.25 C61.3427724,56.25 65.5344828,52.0525 65.5344828,46.875",
  id: "Fill-4",
  fill: "#CC3300"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.9241379,54.375 C54.9241379,49.1975 50.7324276,45 45.562069,45 C40.3917103,45 36.2,49.1975 36.2,54.375 C36.2,59.5525 40.3917103,63.75 45.562069,63.75 C50.7324276,63.75 54.9241379,59.5525 54.9241379,54.375",
  id: "Fill-6",
  fill: "#FF6666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2275862,54.375 C16.2275862,49.1975 20.4192966,45 25.5896552,45 C30.7600138,45 34.9517241,49.1975 34.9517241,54.375 C34.9517241,59.5525 30.7600138,63.75 25.5896552,63.75 C20.4192966,63.75 16.2275862,59.5525 16.2275862,54.375",
  id: "Fill-8",
  fill: "#993333"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#669966",
  points: "25.5896552 51.25 26.837931 52.5 28.0862069 51.25 26.837931 50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.5689655,61.875 C40.5689655,56.6975 44.7606759,52.5 49.9310345,52.5 C55.1013931,52.5 59.2931034,56.6975 59.2931034,61.875 C59.2931034,67.0525 55.1013931,71.25 49.9310345,71.25 C44.7606759,71.25 40.5689655,67.0525 40.5689655,61.875",
  id: "Fill-12",
  fill: "#993333"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14",
  fill: "#669966",
  points: "49.9310345 58.75 51.1793103 60 52.4275862 58.75 51.1793103 57.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.3137931,56.25 C44.3137931,51.0725 40.1220828,46.875 34.9517241,46.875 C29.7813655,46.875 25.5896552,51.0725 25.5896552,56.25 C25.5896552,61.4275 29.7813655,65.625 34.9517241,65.625 C40.1220828,65.625 44.3137931,61.4275 44.3137931,56.25",
  id: "Fill-16",
  fill: "#CC3300"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.837931,61.25 C26.837931,56.0725 22.6462207,51.875 17.4758621,51.875 C12.3055034,51.875 8.1137931,56.0725 8.1137931,61.25 C8.1137931,66.4275 12.3055034,70.625 17.4758621,70.625 C22.6462207,70.625 26.837931,66.4275 26.837931,61.25",
  id: "Fill-18",
  fill: "#CC3300"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.9517241,63.75 C34.9517241,58.5725 30.7600138,54.375 25.5896552,54.375 C20.4192966,54.375 16.2275862,58.5725 16.2275862,63.75 C16.2275862,68.9275 20.4192966,73.125 25.5896552,73.125 C30.7600138,73.125 34.9517241,68.9275 34.9517241,63.75",
  id: "Fill-20",
  fill: "#FF6666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.1137931,61.25 C5.35635172,61.25 3.12068966,63.48875 3.12068966,66.25 L3.12068966,67.5 C3.12068966,84.06875 16.5334138,97.5 33.0793103,97.5 L65.5344828,97.5 L65.5344828,61.25 L8.1137931,61.25 Z",
  id: "Fill-22",
  fill: "#003333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.4,23.75 L69.9034483,23.75 C62.3201724,23.75 56.1724138,29.90625 56.1724138,37.5 L56.1724138,97.5 L86.1310345,97.5 L86.1310345,37.5 C86.1310345,29.90625 79.9832759,23.75 72.4,23.75",
  id: "Fill-24",
  fill: "#66CC99"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-26",
  fill: "#66CC99",
  points: "65.5344828 65 76.7689655 65 76.7689655 3.75 65.5344828 3.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.7689655,1.875 L65.5344828,1.875 C64.8454345,1.875 64.2862069,2.435 64.2862069,3.125 L64.2862069,6.875 C64.2862069,7.565 64.8454345,8.125 65.5344828,8.125 L76.7689655,8.125 C77.4580138,8.125 78.0172414,7.565 78.0172414,6.875 L78.0172414,3.125 C78.0172414,2.435 77.4580138,1.875 76.7689655,1.875",
  id: "Fill-28",
  fill: "#66CC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.6482759,0 L68.6551724,0 C67.9661241,0 67.4068966,0.56 67.4068966,1.25 L67.4068966,7.5 C67.4068966,8.19 67.9661241,8.75 68.6551724,8.75 L73.6482759,8.75 C74.3373241,8.75 74.8965517,8.19 74.8965517,7.5 L74.8965517,1.25 C74.8965517,0.56 74.3373241,0 73.6482759,0",
  id: "Fill-29",
  fill: "#003333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.4068966,1.875 L67.4068966,9.375 C67.4068966,10.065 67.9661241,10.625 68.6551724,10.625 L73.6482759,10.625 C74.3373241,10.625 74.8965517,10.065 74.8965517,9.375 L74.8965517,1.875 L67.4068966,1.875 Z",
  id: "Fill-30",
  fill: "#336666"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-31",
  fill: "#339999",
  points: "56.1724138 75 86.1310345 75 86.1310345 37.5 56.1724138 37.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.0586207,75 L40.213831,75 C30.7643828,75 21.6145207,78.3175 14.3551724,84.375 C21.6145207,90.4325 30.7643828,93.75 40.213831,93.75 L48.0586207,93.75 L48.0586207,75 Z",
  id: "Fill-32",
  fill: "#669933"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.6896552,97.5 L43.6896552,81.25 L35.8448655,81.25 C26.3954172,81.25 17.2455552,84.5675 9.9862069,90.625 C13.5556517,93.60375 17.5832138,95.915 21.8772828,97.5 L43.6896552,97.5 Z",
  id: "Fill-33",
  fill: "#336633"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.565517,16.25 L82.3862069,16.25 C78.9397172,16.25 76.1448276,19.048125 76.1448276,22.5 L76.1448276,97.5 L139.806897,97.5 L139.806897,22.5 C139.806897,19.048125 137.012007,16.25 133.565517,16.25",
  id: "Fill-34",
  fill: "#666699"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-35",
  fill: "#FFFFFF",
  points: "78.0172414 97.5 137.934483 97.5 137.934483 15 78.0172414 15"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-36",
  fill: "#CCFFFF",
  points: "78.0172414 25 137.934483 25 137.934483 23.75 78.0172414 23.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-37",
  fill: "#CCFFFF",
  points: "78.0172414 32.5 137.934483 32.5 137.934483 31.25 78.0172414 31.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-38",
  fill: "#CCFFFF",
  points: "78.0172414 40 137.934483 40 137.934483 38.75 78.0172414 38.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-39",
  fill: "#CCFFFF",
  points: "78.0172414 47.5 137.934483 47.5 137.934483 46.25 78.0172414 46.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-40",
  fill: "#CCFFFF",
  points: "78.0172414 55 137.934483 55 137.934483 53.75 78.0172414 53.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-41",
  fill: "#CCFFFF",
  points: "78.0172414 62.5 137.934483 62.5 137.934483 61.25 78.0172414 61.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-42",
  fill: "#CCFFFF",
  points: "78.0172414 70 137.934483 70 137.934483 68.75 78.0172414 68.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-43",
  fill: "#CCFFFF",
  points: "78.0172414 77.5 137.934483 77.5 137.934483 76.25 78.0172414 76.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-44",
  fill: "#CCFFFF",
  points: "78.0172414 85 137.934483 85 137.934483 83.75 78.0172414 83.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-45",
  fill: "#CCFFFF",
  points: "78.0172414 92.5 137.934483 92.5 137.934483 91.25 78.0172414 91.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-46",
  fill: "#99CCCC",
  points: "113.592479 52.5 109.699731 49.7875 105.806359 52.5 101.734483 49.6625 102.092114 48.874375 105.806359 51.4625 109.699731 48.75 113.592479 51.4625 117.485228 48.75 121.379224 51.4625 125.094093 48.874375 125.451724 49.6625 121.379224 52.5 117.485228 49.7875"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-47",
  fill: "#99CCCC",
  points: "88.3100248 60.625 84.2587455 57.7875 84.6201214 57.00125 88.3100248 59.58625 92.1815524 56.875 96.05308 59.58625 99.9239834 56.875 103.796135 59.58625 107.668287 56.875 111.720814 59.7125 111.359439 60.49875 107.668287 57.91375 103.796135 60.625 99.9239834 57.91375 96.05308 60.625 92.1815524 57.91375"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-48",
  fill: "#99CCCC",
  points: "87.4768007 30 83.6346076 27.16 84.0265662 26.395 87.4768007 28.945625 91.1236386 26.25 94.7711007 28.945625 98.2219593 26.395 98.6139179 27.16 94.7711007 30 91.1236386 27.305"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-49",
  fill: "#99CCCC",
  points: "87.3250728 52.5 83.3224762 49.66 83.7306624 48.895 87.3250728 51.445625 91.1235762 48.75 94.9227038 51.445625 98.5177383 48.895 98.9259245 49.66 94.9227038 52.5 91.1235762 49.805"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-50",
  fill: "#99CCCC",
  points: "121.804387 30 117.962194 27.16 118.354152 26.395 121.804387 28.945625 125.451225 26.25 129.098687 28.945625 132.549546 26.395 132.941504 27.16 129.098687 30 125.451225 27.305"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-51",
  fill: "#99CCCC",
  points: "107.976486 30 104.329024 27.305 100.878166 29.855 100.486207 29.09 104.329024 26.25 107.976486 28.945625 111.623324 26.25 115.465517 29.09 115.073559 29.855 111.623324 27.305"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-52",
  fill: "#99CCCC",
  points: "88.35877 68.125 84.2588079 65.288125 84.6114459 64.496875 88.35877 67.09 92.282101 64.375 96.2060562 67.09 100.130011 64.375 104.231222 67.211875 103.87796 68.003125 100.130011 65.41 96.2060562 68.125 92.282101 65.41"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-53",
  fill: "#99CCCC",
  points: "110.559543 37.5 106.415268 34.6625 106.785381 33.87625 110.559543 36.46125 114.51845 33.75 118.477981 36.46125 122.436888 33.75 126.396419 36.46125 130.357199 33.75 134.501474 36.5875 134.131985 37.37375 130.357199 34.78875 126.396419 37.5 122.436888 34.78875 118.477981 37.5 114.51845 34.78875"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-54",
  fill: "#99CCCC",
  points: "87.5505738 37.5 83.3226634 34.663125 83.6865359 33.871875 87.5505738 36.465 91.5962359 33.75 95.6431462 36.465 99.6900566 33.75 103.919215 36.586875 103.555343 37.378125 99.6900566 34.785 95.6431462 37.5 91.5962359 34.785"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-55",
  fill: "#99CCCC",
  points: "91.1247621 45.625 87.4773 42.93 84.0264414 45.48 83.6344828 44.715 87.4773 41.875 91.1247621 44.570625 94.7716 41.875 98.6137931 44.715 98.2218345 45.48 94.7716 42.93"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-56",
  fill: "#99CCCC",
  points: "114.99317 45.625 110.946883 42.91 106.899349 45.625 102.670814 42.788125 103.034687 41.996875 106.899349 44.59 110.946883 41.875 114.99317 44.59 119.038832 41.875 123.267366 44.711875 122.903494 45.503125 119.038832 42.91"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-57",
  fill: "#99CCCC",
  points: "87.9802928 75.625 83.6344203 72.78875 83.990179 71.99125 87.9802928 74.595 92.1482859 71.875 96.316279 74.595 100.484896 71.875 104.653513 74.595 108.822131 71.875 112.990748 74.595 116.98211 71.99125 117.337869 72.789375 112.990748 75.625 108.822131 72.905 104.653513 75.625 100.484896 72.905 96.316279 75.625 92.1482859 72.905"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.5,17.5 C90.5,18.19 89.9407724,18.75 89.2517241,18.75 C88.5626759,18.75 88.0034483,18.19 88.0034483,17.5 C88.0034483,16.81 88.5626759,16.25 89.2517241,16.25 C89.9407724,16.25 90.5,16.81 90.5,17.5",
  id: "Fill-58",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.2586207,17.5 C84.2586207,18.19 83.6993931,18.75 83.0103448,18.75 C82.3212966,18.75 81.762069,18.19 81.762069,17.5 C81.762069,16.81 82.3212966,16.25 83.0103448,16.25 C83.6993931,16.25 84.2586207,16.81 84.2586207,17.5",
  id: "Fill-59",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.7413793,17.5 C96.7413793,18.19 96.1821517,18.75 95.4931034,18.75 C94.8040552,18.75 94.2448276,18.19 94.2448276,17.5 C94.2448276,16.81 94.8040552,16.25 95.4931034,16.25 C96.1821517,16.25 96.7413793,16.81 96.7413793,17.5",
  id: "Fill-60",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.982759,17.5 C102.982759,18.19 102.423531,18.75 101.734483,18.75 C101.045434,18.75 100.486207,18.19 100.486207,17.5 C100.486207,16.81 101.045434,16.25 101.734483,16.25 C102.423531,16.25 102.982759,16.81 102.982759,17.5",
  id: "Fill-61",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.224138,17.5 C109.224138,18.19 108.66491,18.75 107.975862,18.75 C107.286814,18.75 106.727586,18.19 106.727586,17.5 C106.727586,16.81 107.286814,16.25 107.975862,16.25 C108.66491,16.25 109.224138,16.81 109.224138,17.5",
  id: "Fill-62",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.465517,17.5 C115.465517,18.19 114.90629,18.75 114.217241,18.75 C113.528193,18.75 112.968966,18.19 112.968966,17.5 C112.968966,16.81 113.528193,16.25 114.217241,16.25 C114.90629,16.25 115.465517,16.81 115.465517,17.5",
  id: "Fill-63",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.706897,17.5 C121.706897,18.19 121.147669,18.75 120.458621,18.75 C119.769572,18.75 119.210345,18.19 119.210345,17.5 C119.210345,16.81 119.769572,16.25 120.458621,16.25 C121.147669,16.25 121.706897,16.81 121.706897,17.5",
  id: "Fill-64",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.948276,17.5 C127.948276,18.19 127.389048,18.75 126.7,18.75 C126.010952,18.75 125.451724,18.19 125.451724,17.5 C125.451724,16.81 126.010952,16.25 126.7,16.25 C127.389048,16.25 127.948276,16.81 127.948276,17.5",
  id: "Fill-65",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.189655,17.5 C134.189655,18.19 133.630428,18.75 132.941379,18.75 C132.252331,18.75 131.693103,18.19 131.693103,17.5 C131.693103,16.81 132.252331,16.25 132.941379,16.25 C133.630428,16.25 134.189655,16.81 134.189655,17.5",
  id: "Fill-66",
  fill: "#99CCCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.2517241,12.5 C88.9065759,12.5 88.6275862,12.723125 88.6275862,13 L88.6275862,17 C88.6275862,17.27625 88.9065759,17.5 89.2517241,17.5 C89.5968724,17.5 89.8758621,17.27625 89.8758621,17 L89.8758621,13 C89.8758621,12.723125 89.5968724,12.5 89.2517241,12.5",
  id: "Fill-67",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.0103448,12.5 C82.6651966,12.5 82.3862069,12.723125 82.3862069,13 L82.3862069,17 C82.3862069,17.27625 82.6651966,17.5 83.0103448,17.5 C83.3554931,17.5 83.6344828,17.27625 83.6344828,17 L83.6344828,13 C83.6344828,12.723125 83.3554931,12.5 83.0103448,12.5",
  id: "Fill-68",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.4931034,12.5 C95.1479552,12.5 94.8689655,12.723125 94.8689655,13 L94.8689655,17 C94.8689655,17.27625 95.1479552,17.5 95.4931034,17.5 C95.8382517,17.5 96.1172414,17.27625 96.1172414,17 L96.1172414,13 C96.1172414,12.723125 95.8382517,12.5 95.4931034,12.5",
  id: "Fill-69",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.734483,12.5 C101.389334,12.5 101.110345,12.723125 101.110345,13 L101.110345,17 C101.110345,17.27625 101.389334,17.5 101.734483,17.5 C102.079631,17.5 102.358621,17.27625 102.358621,17 L102.358621,13 C102.358621,12.723125 102.079631,12.5 101.734483,12.5",
  id: "Fill-70",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.975862,12.5 C107.630714,12.5 107.351724,12.723125 107.351724,13 L107.351724,17 C107.351724,17.27625 107.630714,17.5 107.975862,17.5 C108.32101,17.5 108.6,17.27625 108.6,17 L108.6,13 C108.6,12.723125 108.32101,12.5 107.975862,12.5",
  id: "Fill-71",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.217241,12.5 C113.872093,12.5 113.593103,12.723125 113.593103,13 L113.593103,17 C113.593103,17.27625 113.872093,17.5 114.217241,17.5 C114.56239,17.5 114.841379,17.27625 114.841379,17 L114.841379,13 C114.841379,12.723125 114.56239,12.5 114.217241,12.5",
  id: "Fill-72",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.458621,12.5 C120.113472,12.5 119.834483,12.723125 119.834483,13 L119.834483,17 C119.834483,17.27625 120.113472,17.5 120.458621,17.5 C120.803769,17.5 121.082759,17.27625 121.082759,17 L121.082759,13 C121.082759,12.723125 120.803769,12.5 120.458621,12.5",
  id: "Fill-73",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.7,12.5 C126.354852,12.5 126.075862,12.723125 126.075862,13 L126.075862,17 C126.075862,17.27625 126.354852,17.5 126.7,17.5 C127.045148,17.5 127.324138,17.27625 127.324138,17 L127.324138,13 C127.324138,12.723125 127.045148,12.5 126.7,12.5",
  id: "Fill-74",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.941379,12.5 C132.596231,12.5 132.317241,12.723125 132.317241,13 L132.317241,17 C132.317241,17.27625 132.596231,17.5 132.941379,17.5 C133.286528,17.5 133.565517,17.27625 133.565517,17 L133.565517,13 C133.565517,12.723125 133.286528,12.5 132.941379,12.5",
  id: "Fill-75",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-76",
  fill: "#CCCCCC",
  points: "101.734483 90 134.189655 90 134.189655 52.5 101.734483 52.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-77",
  fill: "#999999",
  points: "104.855172 85 131.068966 85 131.068966 55 104.855172 55"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-78",
  fill: "#333333",
  points: "104.855172 85 131.068966 85 131.068966 70 104.855172 70"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-79",
  fill: "#666666",
  points: "116.089655 82.5 131.068966 82.5 131.068966 75 116.089655 75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-80",
  fill: "#999999",
  points: "116.089655 78.75 131.068966 78.75 131.068966 75 116.089655 75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.331034,67.5 L120.77069,67.5 C118.184886,67.5 116.089655,69.598125 116.089655,72.1875 L116.089655,72.8125 C116.089655,75.401875 118.184886,77.5 120.77069,77.5 L129.82069,77.5 L129.82069,75 C129.82069,70.858125 126.467197,67.5 122.331034,67.5",
  id: "Fill-81",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.451724,75 L122.955172,75 C121.576452,75 120.458621,76.119375 120.458621,77.5 L127.948276,77.5 C127.948276,76.119375 126.830445,75 125.451724,75",
  id: "Fill-82",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.57931,76.25 C122.890262,76.25 122.331034,76.81 122.331034,77.5 L131.068966,77.5 L131.068966,76.25 L123.57931,76.25 Z",
  id: "Fill-83",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-84",
  fill: "#999999",
  points: "105.47931 87.5 127.948276 87.5 127.948276 86.25 105.47931 86.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-85",
  fill: "#FFCC66",
  points: "106.727586 50.833125 100.069907 57.5 96.7413793 54.166875 103.399059 47.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-86",
  fill: "#FFCC66",
  points: "137.310345 85.833125 130.652666 92.5 127.324138 89.166875 133.981817 82.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-87",
  fill: "#FFCC66",
  points: "126.075862 52.708125 132.733541 59.375 136.062069 56.041875 129.40439 49.375"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-88",
  fill: "#FFCC66",
  points: "98.6137931 85.208125 105.271472 91.875 108.6 88.541875 101.942321 81.875"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.855172,65.625 L104.855172,76.875 C111.059728,76.875 116.089655,71.838125 116.089655,65.625 L104.855172,65.625 Z",
  id: "Fill-89",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-90",
  fill: "#FFFFFF",
  points: "104.855172 65.625 104.855172 61.875 112.344828 65.625"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.458621,72.5 C120.458621,73.19 119.899393,73.75 119.210345,73.75 C118.521297,73.75 117.962069,73.19 117.962069,72.5 C117.962069,71.81 118.521297,71.25 119.210345,71.25 C119.899393,71.25 120.458621,71.81 120.458621,72.5",
  id: "Fill-91",
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-92",
  fill: "#FF9900",
  points: "89.2517241 55 86.1310345 58.125 126.075862 97.5 132.317241 97.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-93",
  fill: "#FFCC99",
  points: "86.1310345 58.125 82.3862069 51.25 89.2517241 55"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-94",
  fill: "#666666",
  points: "84.8096097 52.57325 82.3860821 51.250125 83.7073821 53.677"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.3206897,97.5 L39.3206897,88.75 L31.4759,88.75 C22.3609897,88.75 13.5300621,91.844375 6.40053448,97.5 L39.3206897,97.5 Z",
  id: "Fill-95",
  fill: "#669933"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-96",
  fill: "#66CC66",
  points: "29.3344828 61.25 26.837931 61.25 28.0862069 60"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-97",
  fill: "#99CC99",
  points: "34.9517241 55 33.7034483 56.25 32.4551724 55 33.7034483 53.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-98",
  fill: "#66CC66",
  points: "48.0586207 50.625 46.8103448 51.875 45.562069 50.625 46.8103448 49.375"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-99",
  fill: "#99CC99",
  points: "16.2275862 56.875 14.9793103 58.125 13.7310345 56.875 14.9793103 55.625"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.4344828,75 L36.0926483,86.3575 C36.5451483,86.81 36.8241379,87.435 36.8241379,88.125 C36.8241379,89.505625 35.7063069,90.625 34.3275862,90.625 C33.6385379,90.625 33.0144,90.345625 32.5625241,89.8925 L24.9655172,97.5 L56.1724138,97.5 L56.1724138,75 L47.4344828,75 Z",
  id: "Fill-100",
  fill: "#FFCC66"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.1586207,97.5 C66.1586207,94.764375 65.7972448,91.965625 65.0695,89.236875 C64.8217172,89.319375 64.5614517,89.375 64.2862069,89.375 C62.9074862,89.375 61.7896552,88.255625 61.7896552,86.875 C61.7896552,85.809375 62.458731,84.90625 63.3961862,84.545625 C61.7603207,80.93875 59.3804828,77.628125 56.1724138,75 L49.5409483,81.640625 C50.512731,82.170625 51.1793103,83.19 51.1793103,84.375 C51.1793103,86.10125 49.7824897,87.5 48.0586207,87.5 C46.8752552,87.5 45.8572862,86.8325 45.3280172,85.859375 L33.7034483,97.5 L66.1586207,97.5 Z",
  id: "Fill-101",
  fill: "#FFFF99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.9310345,97.5 C49.9310345,95.429375 51.6080931,93.75 53.6758621,93.75 C55.743631,93.75 57.4206897,95.429375 57.4206897,97.5 L49.9310345,97.5 Z",
  id: "Fill-102",
  fill: "#FFCC66"
}))))));

function SvgIngredientsEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "151px",
    height: "98px",
    viewBox: "0 0 151 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrations/Ingredients empty state") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredientsEmptyState);
export default __webpack_public_path__ + "static/media/ingredients-empty-state.f8848af5.svg";
export { ForwardRef as ReactComponent };